import { BoxProps } from '@mui/material'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import React from 'react'
import { useIntl } from 'react-intl'

import m from 'pages/Login/messages'

function CidaasLoginButton(props: BoxProps) {
  const { formatMessage: f } = useIntl()

  return (
    <Box {...props}>
      <form acceptCharset="UTF-8" action="/auth/cidaas" method="POST">
        <Button
          fullWidth
          startIcon={
            <img
              alt="cidaas logo"
              src="/images/integrations/cidaas_logo.png"
              style={{
                height: '16px',
                left: 8,
                position: 'absolute',
                top: 7,
              }}
            />
          }
          type="submit"
        >
          {f(m.signInWithCidaas)}
        </Button>
      </form>
    </Box>
  )
}

export default CidaasLoginButton
